import React, { useMemo } from 'react';
import { HealthPlanReportIcon } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core';

import { useFavoriteReportHandler } from '../../hooks';
import { ReportTypeKeys } from '../../report.types';
import ReportCardBase, { ReportCardBaseProps } from '../ReportCardBase';

import { useHealthPlanEnrollmentsBriefQuery } from './queries';

interface Props extends ReportCardBaseProps {}
const TEST_ID = 'health-enrollment-report-card';
const HealthPlanEnrollmentCard: React.FC<Props> = ({ isFavoriteMode }) => {
  const {
    observingOrganization: { type },
  } = useCurrentOrganization();
  const isSystem = useMemo(() => type === OrganizationTypes.system, [type]);

  const {
    data: { enrolledPlans },
    isLoading,
  } = useHealthPlanEnrollmentsBriefQuery();
  const childrenNode = useMemo(() => {
    if (!isSystem) {
      return (
        <ReportCardBase.DescriptionBase
          isLoading={isLoading}
          testId={TEST_ID}
          title="Current plan year totals"
          items={[
            {
              label: 'Enrolled in health plan',
              value: `${enrolledPlans || 0}`,
            },
          ]}
        />
      );
    }
    return null;
  }, [enrolledPlans, isLoading, isSystem]);
  const { isFavorite, handleToggleReportKey } = useFavoriteReportHandler(ReportTypeKeys.HealthPlanEnrollment);

  return (
    <ReportCardBase
      // isNew

      testId={TEST_ID}
      isWideMode={isFavoriteMode}
      url={ROUTES.HEALTH_PLAN_ENROLLMENTS_REPORT}
      isFavorite={isFavorite}
      onChangeFavorite={handleToggleReportKey}
      icon={
        <HealthPlanReportIcon
          size={isFavoriteMode ? '50px' : '40px'}
          color={isFavoriteMode ? 'iconAccent' : 'iconDisabled'}
        />
      }
      title="Health Plan Enrollment"
      description="View employee health plan
deductible enrollments, coverage
details, and HRA status"
    >
      {childrenNode}
    </ReportCardBase>
  );
};
export default HealthPlanEnrollmentCard;
